import React, {useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import MindsetsJsSDK, {authUtils, ErrorMessageAction, LoadingAction} from "mindsets-js-sdk";
import useAuth from "../../hooks/useAuth";

export default function () {
    useAuth(true);
    const dispatch = useDispatch();
    const me = useSelector(state => state.me);
    const [new_password, setNewPassword] = useState('');
    const [confirm_password, setConfirmPassword] = useState('');

    function validate() {
        if (!new_password) {
            dispatch(ErrorMessageAction('Please enter your new password'));
            return false;
        }
        if (!confirm_password) {
            dispatch(ErrorMessageAction('Please enter your new password in both fields'));
            return false;
        }
        if (confirm_password !== new_password) {
            dispatch(ErrorMessageAction('Passwords do not match'));
            return false;
        }
        if (!authUtils.isValidPassword(new_password)) {
            dispatch(ErrorMessageAction('Invalid password. Must be at least 6 characters long'));
            return false;
        }

        return true;
    }

    function submit() {
        if (validate()) {
            Promise.resolve()
                .then(() => dispatch(LoadingAction(true)))
                .then(() => MindsetsJsSDK().API.put(`password/${me.id}`, {new_password}))
                .then(() => window.location.href = '/')
                .then(() => dispatch(LoadingAction(false)));
        }
    }

    if (!me) {
        return null;
    }

    return (
        <div id='password-reset'>
            <div className="container">
                <div className="password-container z-depth-1 flex-column flex-vh-center">
                    <div className="password-icon">
                        <img src={`${process.env.PUBLIC_S3_ASSETS_URL}/application/icon_password.svg`} alt='Password'/>
                    </div>

                    <h4 className="header-new">{`Change Your Password`}</h4>,
                    <div className="flex-column flex-vh-center">
                        <div className="section">
                            <div className="password-description center-align">Enter your new password below *</div>
                        </div>

                        <input
                            className="password-new-password input-new browser-default"
                            type="password"
                            placeholder="Password, minimum 6 characters"
                            maxLength="30"
                            value={new_password}
                            onChange={event => setNewPassword(event.target.value)}
                        />

                        <div className="section">
                            <div className="password-description center-align">Confirm password *</div>
                        </div>

                        <input
                            className="password-new-password input-new browser-default"
                            type="password"
                            placeholder="Re-type password"
                            maxLength="30"
                            value={confirm_password}
                            onChange={event => setConfirmPassword(event.target.value)}
                        />

                        <button
                            className="password-submit btn btn-challenge"
                            onClick={submit}
                        >
                            Submit
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};
